import axios from "axios";
import { BACKEND_URL } from "./backendBase";

const client = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

// Always parse FastAPI 422 detail as a string for safe rendering.
export function formatApiError(err) {
  // Distinct: real network failure (CORS, DNS, offline, blocked).
  // Axios sets err.code === "ERR_NETWORK" and err.response is undefined.
  if (err?.code === "ERR_NETWORK" || (!err?.response && err?.message === "Network Error")) {
    return "Falha de conexão. Verifique sua internet e tente novamente.";
  }
  if (err?.code === "ECONNABORTED") {
    return "A conexão demorou demais. Tente novamente.";
  }
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const authApi = {
  register: ({ name, email, password, phone }) =>
    client
      .post("/api/auth/register", { name, email, password, phone: phone || null })
      .then((r) => r.data),
  login: ({ email, password }) =>
    client.post("/api/auth/login", { email, password }).then((r) => r.data),
  logout: () => client.post("/api/auth/logout").then((r) => r.data),
  me: () => client.get("/api/auth/me").then((r) => r.data),
  refresh: () => client.post("/api/auth/refresh").then((r) => r.data),
  forgotPassword: ({ email }) =>
    client.post("/api/auth/forgot-password", { email }).then((r) => r.data),
  resetPassword: ({ token, password }) =>
    client.post("/api/auth/reset-password", { token, password }).then((r) => r.data),
  migrate: (payload) => client.post("/api/auth/migrate", payload).then((r) => r.data),
  googleExchange: ({ session_id }) =>
    client.post("/api/auth/google/exchange", { session_id }).then((r) => r.data),
  updateProfile: (payload) =>
    client.patch("/api/auth/me/profile", payload).then((r) => r.data),
};

export default client;
